import SignOX from "../../../../src/events/2022/07/sign-ox/main";
import * as React from 'react';
export default {
  SignOX,
  React
};